<template>
  <div
    class="messenger-tag"
    @click.prevent="$emit('click')"
    :class="{'no-actions': noActions}"
  >
    <div class="messenger-tag__name">{{ tag.name }}</div>
    <div
      v-if="!noDelete"
      class="messenger-tag__remove"
      @click.prevent="onRemove"
    >
      <feather-icon
        icon="XIcon"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    tag: {
      type: Object,
      required: true
    },
    noDelete: {
      type: Boolean,
      default: false
    },
    noActions: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    async onRemove () {
      this.$emit('delete', this.tag)
    }
  }
}
</script>
